import o from "../assets/fonts/poppins-v20-latin-500.woff.es.js";
import f from "../assets/fonts/poppins-v20-latin-500.woff2.es.js";
import r from "../assets/fonts/poppins-v20-latin-600.woff.es.js";
import t from "../assets/fonts/poppins-v20-latin-600.woff2.es.js";
import l from "../assets/fonts/poppins-v20-latin-700.woff.es.js";
import m from "../assets/fonts/poppins-v20-latin-700.woff2.es.js";
import n from "../assets/fonts/poppins-v20-latin-regular.woff.es.js";
import i from "../assets/fonts/poppins-v20-latin-regular.woff2.es.js";
import { globalCss as a } from "../components/stitches.config.es.js";
const p = [{
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  src: `local(""), url("${i}") format("woff2"), url("${n}") format("woff")`
}, {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  src: `local(""), url("${f}") format("woff2"), url("${o}") format("woff")`
}, {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  src: `local(""), url("${t}") format("woff2"), url("${r}") format("woff")`
}, {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  src: `local(""), url("${m}") format("woff2"), url("${l}") format("woff")`
}], d = a({
  "@font-face": p
});
export {
  d as default,
  d as usePoppinsFont
};
//# sourceMappingURL=usePoppinsFont.es.js.map
